import './EditComponent.css';
import { forwardRef, useContext, useEffect, useReducer, useState } from 'react';
import {
  UserData,
  userDataReducer,
  UserUpdateAction,
  ORG_SHARED_DATA,
  init_newUserDataObj,
  UserOrganizations,
} from '../interfaces/UserInterfaces';
import {
  Claims,
  EventTypes,
  ExternalEnumRecord,
  SearchLogRequestBody,
  SearchLogResponse,
  claimEnabledInContext,
  claimRequiredInContext,
  claimValueValidInContext,
  claimsListToSchema,
  claimsValidInContext,
} from '../interfaces/APIInterface';
import { COSMOS_API, GET_ENDPOINT, POST_ENDPOINT } from '../api/API';
import { isNullUndefEmpty, useQuery } from '../ts/common';
import { useNavigate } from 'react-router-dom';
import PopUp from './PopUp';
import { AdminContext } from '../contexts/AdminContext';
import { ApplicationEdit } from './ApplicationEdit';
import { country_options } from '../data/countries';
import { UserGroupReference, adminCanViewSomeGroups, rolePermission } from '../interfaces/ApplicationInterfaces';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Autocomplete from '@mui/material/Autocomplete';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TablePagination from "@mui/material/TablePagination";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSnackbar } from 'notistack';
import { AddOrgToUser } from './AddOrgToUser';
import APPSETTINGS from '../settings.json';
import { TabPanel } from './Tabs';
import { AppEnvSetting } from '../ts/common'; 
import { ClaimsEdit } from './ClaimsEdit';
import { Tooltip } from '@mui/material';
import { EditGroupMembership } from './EditGroupMembership';

// Called in AuditLogs method
const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Called by changeIsActive method
const mergeUpdatedProvisioningStatuses = (oldOrgs: UserOrganizations, newOrgs: Record<string, Record<string, string> >) => {
  return Object.keys(oldOrgs ?? {}).reduce((acc: UserOrganizations, orgId) => {
    if (newOrgs?.hasOwnProperty(orgId)) {
      acc[orgId] = (oldOrgs.hasOwnProperty(orgId) ? Object.keys(oldOrgs[orgId]) : []).reduce((aacc: Record<string, Record<string, string> >, appId) => {
        if (newOrgs[orgId].hasOwnProperty(appId)) {
          aacc[appId] = {
            ...oldOrgs[orgId][appId],
            userProvisionStatus: newOrgs[orgId][appId]
          };
        } else {
          aacc[appId] = oldOrgs[orgId][appId];
        }
        return aacc;
      }, {});
    } else {
      acc[orgId] = oldOrgs?.[orgId];
    }
    return acc;
  }, {});
}

function EditComponent() {
  const [viewPanel, setViewPanel] = useState(0);
  const [generalEdit, setGeneralEdit] = useState<boolean>(false);
  const [emailEdit, setEmailEdit] = useState<boolean>(false);
  const [showAuditLogs, setShowAuditLogs] = useState<boolean>(false);
  const [auditField, setAuditField] = useState<
    'email' | 'login' | 'external' | 'changes'
  >();
  const [selectedApp, setSelectedApp] = useState<string>('');
  const [adminProvisionableApps, setAdminProvisionableApps] = useState<
    Array<string>
  >([]);
  const [temporaryEdit, dispatch] = useReducer(userDataReducer, {
    ...init_newUserDataObj(),
  });
  const [userActualState, setUserActualState] = useState<UserData>(
    init_newUserDataObj()
  );
  const [userGroupState, setUserGroupState] = useState<Array<UserGroupReference>>(
    []
  );
  const [provisionAppPopup, setProvisionAppPopup] = useState(false);
  const [provisionOrgPopUp, setProvisionOrgPopup] = useState(false);
  const [editingGlobalApps, setEditingGlobalApps] = useState(false);
  const [deleteOrgPopUp, setDeleteOrgPopup] = useState(false);
  const [msg, setMsg] = useState<string>('');
  const [showMsg, setShowMsg] = useState<boolean>(false);
  const [editPower, setEditPower] = useState(false);
  const [deleteUserModal, setDeleteUserModal] = useState(false);
  const [emailPasswordFlags, setEmailPasswordFlags] = useState(false);
  const [showEmailPasswordValidations, setShowEmailPasswordValidations] =
    useState(false);

  const [globalClaimsSchema, setGlobalClaimsSchema] = useState<Array<Claims>>([]);

  const { adminCredentials, getToken } = useContext(AdminContext);
  const [organizationToEdit, setOrganizationToEdit] = useState<string>(
    adminCredentials.organizationId
  );
  const [organizationList, setOrganizationList] = useState<
    Array<{ id: string; name: string }>
  >([adminCredentials.organizationList[0]]);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [appClaims, setAppClaims] = useState<Record<string, Array<Claims>>>();
  const [appExternalEnums, setAppExternalEnums] = useState < Record<string, Record<string, ExternalEnumRecord> > >({});

  let lookupString = useQuery();
  let navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    COSMOS_API.GET(GET_ENDPOINT.GetConfiguration, getToken()).then(
      (res) => {
        if (isMounted) {
          if (res?.respBody?.claims) {
            if (isMounted) {
              setGlobalClaimsSchema(res.respBody.claims.filter((cl: Claims) => !cl.isBaseClaim));
            }
          }
        }
      }
    );

    return () => {
      isMounted = false;
    };
  }, []);

  const globalClaimsValid = (claimsContext: Record<string, string>, claimsSchema: Array<Claims>) => {
    if (claimsSchema) {
      let schemaDict: Record<string, Claims> = claimsListToSchema(claimsSchema);
      return claimsSchema.filter(claim => claimRequiredInContext(claim, schemaDict, claim.possibleValues, claimsContext)).every(claim => claimsContext?.[claim.id]) &&
        claimsSchema.filter(claim => Object.keys(claimsContext).includes(claim.id) && claimEnabledInContext(claim, schemaDict, claim.possibleValues, claimsContext))
        .filter(claim => claim.userInputType !== "TextBox").every(clm => {
          return claimValueValidInContext(clm, schemaDict, clm.possibleValues ?? [], claimsContext);
        });
    }
    return true;
  }

  useEffect(() => {
    if (!lookupString.has('user') || !lookupString.has('country')) {
      navigate('/');
      return;
    }
    var appIds = Object.keys(adminCredentials.allApplications);
    if (appIds.length > 0) {
      COSMOS_API.POST({ ids: appIds }, POST_ENDPOINT.ClaimsForApps, getToken()).then(
        (resp) => {
          if (!resp.ok || resp.respBody === undefined || resp.respBody === null || resp.respBody.appClaims === undefined || resp.respBody.appClaims === null || Object.keys(resp.respBody.appClaims).length === 0) {
            let tempClaims: Record<string, Array<Claims>> = {};

            appIds.forEach(id => tempClaims[id] = []);

            setAppClaims(tempClaims);
          }
          else {
            let tempClaims: Record<string, Array<Claims>> = resp.respBody.appClaims;

            setAppClaims(tempClaims);
          }
        }
      )
      fetchUserData();
    }

    if (adminCredentials.isSuperAdmin || (adminCredentials.isOrganizationAdmin && adminCredentials.multiOrg)) {
          setOrganizationList(adminCredentials.organizationList);
    } else {
      setOrganizationList([adminCredentials.organizationList[0]]);
    }
  }, [lookupString, adminCredentials.allApplications, adminCredentials.organizationList]);

  useEffect(() => {
    var userOrgAppIds =
      userActualState.organizations?.[organizationToEdit]
        ? Object.keys(userActualState.organizations[organizationToEdit])
        : [];
    if(selectedApp !== '' && !((userOrgAppIds.some(appId => appId === selectedApp) && (!editingGlobalApps)) || (userActualState.applications && Object.keys(userActualState.applications).some(appId => appId === selectedApp) && editingGlobalApps))){
      setSelectedApp('');
    }
    var provisionableApps: Array<string> = [];
    if (!adminCredentials.isSuperAdmin && !adminCredentials.isOrganizationAdmin) {
      adminCredentials.adminApplications.forEach(
        (adminApp: { id: string; name: string; role: string, isGlobal: boolean }) => {
          if (
            !userOrgAppIds.includes(adminApp.id) &&
            rolePermission(
              'editApplicationData',
              adminApp.role,
              adminCredentials.roleSpecificPermissions,
              adminCredentials.isSuperAdmin
            )
          )
            provisionableApps.push(adminApp.id);
        }
      );
      if (adminCredentials.allApplications[APPSETTINGS.msalClientId] && (!provisionableApps.includes(APPSETTINGS.msalClientId)) && adminCredentials.generalPermissions.manageAdmins) {
        provisionableApps.push(APPSETTINGS.msalClientId);
      }

      setAdminProvisionableApps(provisionableApps);
    } else {
      if (editingGlobalApps) {
        provisionableApps = Object.keys(adminCredentials.allApplications).filter((app: any) => adminCredentials.allApplications[app]?.isGlobal) ?? [];
        setAdminProvisionableApps(provisionableApps);
      } else {
        if (organizationToEdit) {
      COSMOS_API.POST(
        { id: organizationToEdit },
        POST_ENDPOINT.SearchOrganizations,
        getToken()
      ).then((resp) => {
        if (resp.respBody.organizations !== undefined) {
              provisionableApps = resp.respBody.organizations?.length > 0 ? (resp.respBody.organizations[0].appList ?? []) : [];
          if (adminCredentials.allApplications[APPSETTINGS.msalClientId] && (!provisionableApps.includes(APPSETTINGS.msalClientId)) && adminCredentials.generalPermissions.manageAdmins) {
            provisionableApps.push(APPSETTINGS.msalClientId);
          }
          setAdminProvisionableApps(provisionableApps);
        }
      });
        } else {
          setAdminProvisionableApps([]);
        }
      }
    }
  }, [
    adminCredentials.adminApplications,
    userActualState.organizations,
    organizationToEdit,
    editingGlobalApps
  ]);

  async function fetchUserData() {
    console.log(`APPSETTINGS.showGroupsPage: ${APPSETTINGS.showGroupsPage}; adminCanView: ${adminCanViewSomeGroups(adminCredentials)}`);
    var shouldIncludeGroups = APPSETTINGS.showGroupsPage && adminCanViewSomeGroups(adminCredentials);
    var body: any = {
      objectId: lookupString.get('user'),
      country: lookupString.get('country'),
      applications: Object.keys(adminCredentials.allApplications),
      returnNested: true,
      includeGroups: shouldIncludeGroups
    };

    let resp = await COSMOS_API.POST(body, POST_ENDPOINT.GetUserDataAdmin, getToken())
    
      if (resp.ok === false) {
        navigate('/search-users');
        return;
      }
      if (resp.respBody.global === null || resp.respBody.global === undefined) {
        resp.respBody.global = {
          mobileNumber: '',
          faxNumber: '',
          accountNumber: '',
          department: '',
          zipCode: '',
        };
      }

      let userData = resp.respBody;
    let userGroups: Array<UserGroupReference> = []
    if (shouldIncludeGroups) {
      ({ groups: userGroups, ...userData } = userData);
      console.log(`Extract user groups: ${JSON.stringify(userGroups)}`);
      }
      let userOrgs = userData.organizations ? Object.keys(userData.organizations) : [];
    if (userOrgs.length >= 1 && !userOrgs.includes(adminCredentials.organizationId)) {
      setOrganizationToEdit(userOrgs.find(org => org !== 'sharedData') ?? userOrgs[0]);
    } else if (userOrgs.includes(adminCredentials.organizationId)) {
      setOrganizationToEdit(adminCredentials.organizationId);
    } else{
      setOrganizationToEdit('');
      }
      dispatch({
        type: UserUpdateAction.REPLACEUSER,
        payload: { data: structuredClone(userData) },
      });
      setUserActualState({ ...userData });
      setUserGroupState([...userGroups]);

      if (adminCredentials.isSuperAdmin || (adminCredentials.isOrganizationAdmin && adminCredentials.multiOrg)) {
        setEditPower(true);
        setEmailPasswordFlags(true);
        if(userOrgs.length > 0){
          let keys = userOrgs;
          setOrganizationToEdit(keys.find(org => org !== 'sharedData') ?? userOrgs[0]);
        }
      } else {
        let baseRequirement = userOrgs.includes(adminCredentials.organizationId);
        let canEdit = baseRequirement && (adminCredentials.isOrganizationAdmin || (resp.respBody.organizations[adminCredentials.organizationId] && Object.keys(resp.respBody.organizations[adminCredentials.organizationId]).some((element) =>
          adminCredentials.adminApplications.some((value) => value.id === element)))
        );
        if (canEdit) setEditPower(true);
        let canSetFlags = baseRequirement && (adminCredentials.isOrganizationAdmin || Object.keys(resp.respBody.organizations[adminCredentials.organizationId]).some((element) =>
          adminCredentials.adminApplications.some(
            (value) =>
              value.id === element &&
              rolePermission(
                'createNewUsers',
                value.role,
                adminCredentials.roleSpecificPermissions,
                adminCredentials.isSuperAdmin
              )
          )
        ));
        if (canSetFlags) setEmailPasswordFlags(true);
      }
    }

    function postOrgProvision() {
      setProvisionOrgPopup(false);
      fetchUserData();
      enqueueSnackbar(`User has been added to organization`, {variant: 'success'});
    }

  async function changeIsActive(e: any) {
    e.preventDefault();
    triggerPopUp(`Please wait, changing user status...`);

    const res = await COSMOS_API.POST(
      {
        id: userActualState.id,
        country: userActualState.country,
        isActive: !userActualState.isActive
      },
      POST_ENDPOINT.SetUserActiveStatus,
      getToken()
    );
    if (res.ok) {
      setShowMsg(false);
      let updatedActiveFlag = userActualState.isActive;
      if (res.respBody && res.respBody.hasOwnProperty('isActive')) {
        updatedActiveFlag = res.respBody.isActive;
      }
      let modifiedActiveStatus = updatedActiveFlag !== userActualState.isActive;
      if (res.respBody?.updatedApplications) {
        dispatch({
          type: UserUpdateAction.TOPLEVEL,
          payload: { field: 'isActive', data: res.respBody.isActive },
        });
        dispatch({
          type: UserUpdateAction.ORGANIZATIONS,
          payload: {
            data: mergeUpdatedProvisioningStatuses(temporaryEdit.organizations, res.respBody.updatedApplications)
          }
        });
        setUserActualState({
          ...userActualState,
          isActive: res.respBody.isActive,
          organizations: mergeUpdatedProvisioningStatuses(userActualState.organizations, res.respBody.updatedApplications)
        });
      } else {
        if (res.respBody && res.respBody.hasOwnProperty("isActive")) {
          dispatch({
            type: UserUpdateAction.TOPLEVEL,
            payload: { field: 'isActive', data: res.respBody.isActive },
          });
          setUserActualState({
            ...userActualState,
            isActive: res.respBody.isActive,
          });
        }
      }
      if (modifiedActiveStatus) {
        enqueueSnackbar(`User has been set to ${updatedActiveFlag ? "Active" : "Inactive"}`, { variant: 'success' });
      } else {
        enqueueSnackbar(`User has been deactivated for the following organizations: ${Object.keys(res.respBody.updatedApplications).join(", ")}.`, {variant: 'success'});
      }
    } else {
      if ((res.status === 409) && (res.respBody?.errorMessage === "Operation did not result in any changes")) {
        setShowMsg(false);
        enqueueSnackbar(`User not modified: activation status already updated for all administered organizations`, {variant: 'warning'});
      } else {
        triggerPopUp(`The following error occured: ${res.respBody.errorMessage ?? ''}`);
      }
    }
  }

  function cancelEditState(e: any) {
    e.preventDefault();
    dispatch({
      type: UserUpdateAction.REPLACEUSER,
      payload: { data: { ...userActualState } },
    });
    setGeneralEdit(false);
    setEmailEdit(false);
  }

  const appClaimsValid = (appsClaims: Claims[] | undefined, appsData: Record<string, string>) => {
    if (appsClaims) {
      return !(appsClaims.filter(aClaim => aClaim.required).some(aClaim => isNullUndefEmpty(appsData?.[aClaim.id])));
    }
    return true;
  }

  const saveUserGlobalClaims = async (
    globalData: Record<string, string>
  ) => {
    let updatedUser: UserData = { ...userActualState, global: { ...userActualState.global, ...globalData } };
    const res = await COSMOS_API.POST(
      {
        ...updatedUser,
        organizationId: organizationToEdit
      },
      POST_ENDPOINT.SaveUserDataAdmin,
      getToken()
    );
    let resultCode = res.status;
    if (res.ok) {
      setShowMsg(false);
      setUserActualState({ ...updatedUser });
      enqueueSnackbar("User global claims updated", {variant: 'success'});
    } else {
      triggerPopUp(`The user was not updated: ${res.respBody?.userMessage}`);
    }
  }

  const editUserApplication = async (
    applicationData: Record<string, string>,
    appId: string
  ) => {
    let hasPermission = rolePermission("editApplicationData", adminCredentials.adminApplications.find(app => app.id === appId)?.role ?? "", adminCredentials.roleSpecificPermissions, adminCredentials.isSuperAdmin);
    if(adminCredentials.isOrganizationAdmin && ((adminCredentials.organizationId === organizationToEdit) || (adminCredentials.multiOrg && adminCredentials.organizationList.map(orl => orl.id).includes(organizationToEdit))) || (adminCredentials.adminApplications.map(adApp => adApp.id).includes(organizationToEdit)))
      hasPermission = true;
    if (
      !hasPermission
    ) {
      enqueueSnackbar('You do not have permission to edit this app', {
        variant: 'warning',
      });
      return;
    }
    triggerPopUp(`Editing ${adminCredentials.allApplications[appId!]?.name} for ${userActualState.email}. Please wait.`);
    const editingGlobal = editingGlobalApps;
    const body = {
        id: userActualState.id,
        country: userActualState.country,
        organizationId: editingGlobal ? null : organizationToEdit,
        applicationId: appId,
        appData: {...applicationData}
    };

    let resp = await COSMOS_API.POST(
      body,
      POST_ENDPOINT.SaveUserApplicationData,
      getToken()
    );
    if (resp.ok) {
      setShowMsg(false);
      dispatch({
        type: UserUpdateAction.SINGLEAPP,
        payload: editingGlobal ? {
          field: appId,
          data: { appData: applicationData, globalApp: true }
        } : {
          field: organizationToEdit,
          data: { appId: appId, appData: applicationData, globalApp: false },
        },
      });
      if (editingGlobal) {
        setUserActualState({...userActualState, applications: { ...userActualState.applications, [appId]: {...applicationData}}} );
      } else {
        setUserActualState({...userActualState, organizations: { ...userActualState.organizations, [organizationToEdit]: {...userActualState.organizations?.[organizationToEdit], [appId]: {...applicationData}}} });
      }
      
      enqueueSnackbar(
        `Updated Application`,
        {variant: 'success'}
      );
    } else {
      triggerPopUp(`Error! ${resp.respBody.userMessage}`);
    }
  };

  // called by userSave method
  const onEditUserSubmit = async (editedNewData: UserData): Promise<number> => {
    if (!editPower) {
      return -1;
    }
    let resultCode = -1;

    triggerPopUp('Saving changes, please wait.');

    //If generalEdit true call save user details API, otherwise it is an email change and we call that flow
    if (
      generalEdit /* || temporaryEdit.global.facilities !== userActualState.global.facilities || temporaryEdit.global.institution !== userActualState.global.institution */
    ) {
        const body = {
            ...editedNewData,
            organizationId: organizationToEdit,
        }
      const res = await COSMOS_API.POST(
        body,
        POST_ENDPOINT.SaveUserDataAdmin,
        getToken()
      );
      resultCode = res.status;
      if (res.ok) {
        setShowMsg(false);
        setUserActualState({ ...editedNewData });
        enqueueSnackbar("User updated", {variant: 'success'});
      } else {
        triggerPopUp(`The user was not updated: ${res.respBody.userMessage}`);
      }
    } else {
      const body = {
        id: editedNewData.id,
        country: editedNewData.country,
        email: editedNewData.email,
        emailVerificationFlag: true,
        organizationId: organizationToEdit,
      };
      const res = await COSMOS_API.POST(
        body,
        POST_ENDPOINT.SaveUserDataAdmin,
        getToken()
      );
      resultCode = res.status;
      if (res.ok) {
        setShowMsg(false);
        enqueueSnackbar('Email updated', {variant: 'success'});
        setUserActualState({ ...editedNewData });
      } else {
        triggerPopUp('Update email failed');
      }
    }

    return resultCode;
  };

  const userSave = async (e: any) => {
    e.preventDefault();
    if (JSON.stringify(temporaryEdit) === JSON.stringify(userActualState)) {
      enqueueSnackbar('No changes detected.', {variant: 'warning'});
      return;
    }

    if(temporaryEdit.firstName === '' || temporaryEdit.lastName === ''){
      enqueueSnackbar('First name and last name cannot be empty.', {variant: 'warning'});
      return;
    }
    /*
        if (!/^\d{4,15}$/im.test(temporaryEdit.phoneNumber.replaceAll(/[+-\s().]/g, ""))) {
            triggerPopUp("Invalid Phone Number! Please reenter and try again.");
            return;
        }
        */

    /* if (temporaryEdit.userType === "customer" && temporaryEdit.global.facilities.length === 0) {
            triggerPopUp("Customers need at least one facility associated with their account!");
            return;
        } */

    const res = await onEditUserSubmit(temporaryEdit);
    if (res === 200) {
      setGeneralEdit(false);
      setEmailEdit(false);
    }
  };

  /* const setUserFacilities = (newFacilities: Array<Facility>) => {
        dispatch({ type: UserUpdateAction.FACILITIES, payload: { data: newFacilities } });
    }

    const setUserInstitution = (newInstitution: Institution) => {
        dispatch({ type: UserUpdateAction.INSTITUTION, payload: { data: newInstitution } });
    } */

  const triggerPopUp = (msg_content: string) => {
    setMsg(msg_content);
    setShowMsg(true);
  };

  const viewLogs = (criteria: 'email' | 'login' | 'external' | 'changes') => {
    setShowAuditLogs(true);
    setAuditField(criteria);
  };

  const AuditLogs = (props: {
    userEmail: string;
    userID: string;
    logs: 'email' | 'login' | 'external' | 'changes' | undefined;
    setAuditField: (
      field: 'email' | 'login' | 'external' | 'changes' | undefined
    ) => void;
    setShowAuditLogs: (show: boolean) => void;
    showAuditLogs: boolean;
  }) => {
    const [auditData, setAuditData] = useState<Array<SearchLogResponse>>();
    const [auditBody, setAuditBody] = useState<SearchLogRequestBody>({
        affectedUser: '',
        eventType: EventTypes.EMAIL_SENT_EVENT,
        count: 10,
        offset: 0,
      });
    const [numResults, setNumResults] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [focusedLog, setFocusedLog] = useState<
      SearchLogResponse | undefined
    >();
    const [showSingleLog, setShowSingleLog] = useState<boolean>(false);

    useEffect(() => {
      if (focusedLog === undefined) {
        setShowSingleLog(false);
      } else {
        setShowSingleLog(true);
      }
    }, [focusedLog]);

    useEffect(() => {
      if (auditBody !== undefined && auditBody.affectedUser !== '') {
        COSMOS_API.POST(auditBody, POST_ENDPOINT.SearchLogs, getToken()).then(
          (resp) => {
            if (resp.respBody.logs !== undefined) {
              setAuditData(resp.respBody.logs);
              setNumResults(resp.respBody.numResults);
              setCurrentPage(auditBody.offset / auditBody.count);
            } else {
              props.setShowAuditLogs(false);
              props.setAuditField(undefined);
            }
          }
        );
      }
    }, [auditBody]);

    useEffect(() => {
      if (props.logs === 'email')
        setAuditBody({
          affectedUser: props.userID,
          eventType: EventTypes.EMAIL_SENT_EVENT,
          count: 10,
          offset: 0,
        });
      else if (props.logs === 'login')
        setAuditBody({
          affectedUser: props.userID,
          eventType: EventTypes.SIGN_IN,
          count: 10,
          offset: 0,
        });
      else if (props.logs === 'changes')
        setAuditBody({
          affectedUser: props.userID,
          eventType: EventTypes.USER_UPDATED_EVENT,
          count: 10,
          offset: 0,
        });
      else if (props.logs === 'external') {
        setAuditBody({
          affectedUser: props.userID,
          eventType: EventTypes.ENDPOINT_TRIGGERED,
          count: 10,
          offset: 0,
        });
      }
    }, [props.logs]);

    return (
      <Dialog
        onClose={() => {
          props.setShowAuditLogs(false);
          props.setAuditField(undefined);
        }}
        open={props.showAuditLogs}
        fullScreen
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {props.logs} for {props.userEmail}
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => {
                props.setShowAuditLogs(false);
                props.setAuditField(undefined);
              }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent>
          {showSingleLog && focusedLog !== undefined ? (
            <>
              <Box>
                <Button
                  sx={{ ml: 'auto' }}
                  variant="contained"
                  onClick={() => setFocusedLog(undefined)}
                >
                  Return to Results
                </Button>
              </Box>
              <Typography variant="body1">
                <strong>Event Type:</strong> {focusedLog.eventType}
              </Typography>
              <Typography variant="body1">
                <strong>Time:</strong>{' '}
                {new Date(focusedLog.createdAt * 1000).toLocaleString()}
              </Typography>
              <Typography variant="body1">
                <strong>Target Application:</strong>{' '}
                {focusedLog.targetApplication !== undefined
                  ? adminCredentials.allApplications[focusedLog.targetApplication]?.name
                  : 'None'}
              </Typography>
              <Typography variant="body1">
                <strong>Initiated By:</strong>{' '}
                {focusedLog.initiatedBy !== undefined &&
                focusedLog.initiatedBy !== null &&
                focusedLog.initiatedBy !== ''
                  ? focusedLog.initiatedBy
                  : 'user'}
              </Typography>
              <Typography variant="body1">
                <strong>Result:</strong> {focusedLog.result}
              </Typography>
              <Typography variant="body1">
                <strong>Message:</strong> {focusedLog.message}
              </Typography>
              {!!focusedLog.failureResponse && (
                <Typography variant="body1">
                  <strong>Failure Message:</strong> {focusedLog.failureResponse}
                </Typography>
              )}
              {!!focusedLog.failureStackTrace && (
                <Typography variant="body1">
                  <strong>Stack Trace:</strong> {focusedLog.failureStackTrace}
                </Typography>
              )}
            </>
          ) : (
            <>
              <TableContainer component={Container}>
                <Table>
                  <TableHead>
                    <TableRow>
                  <TablePagination
                        count={numResults}
                        page={currentPage}
                        onPageChange={(event: React.MouseEvent<HTMLButtonElement> | null, page: number) =>
                            setAuditBody({
                              ...auditBody,
                              offset: page * auditBody.count,
                            } as SearchLogRequestBody)
                          }
                        rowsPerPage={auditBody.count}
                        onRowsPerPageChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                            setAuditBody({
                              ...auditBody,
                              count: parseInt(event.target.value),
                            } as SearchLogRequestBody);
                          }}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        showFirstButton
                        showLastButton
                      />
                    </TableRow>
                    <TableRow>
                      <TableCell> Created At </TableCell>
                      <TableCell> Application </TableCell>
                      <TableCell> Initiated By </TableCell>
                      <TableCell> Message </TableCell>
                      <TableCell> Result </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {auditData === undefined ? (
                      <TableRow>
                        <TableCell colSpan={5}> Loading... </TableCell>
                      </TableRow>
                    ) : auditData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={5}> No Results </TableCell>
                      </TableRow>
                    ) : (
                      auditData.map((field: SearchLogResponse) => (
                        <TableRow
                          key={field.id}
                          className="logRow"
                          onClick={() => setFocusedLog(field)}
                        >
                          <TableCell>
                            {new Date(field.createdAt * 1000).toLocaleString()}
                          </TableCell>
                          <TableCell>
                            {field.targetApplication !== undefined &&
                            field.targetApplication !== null
                              ? adminCredentials.allApplications[field.targetApplication]?.name
                              : 'None'}
                          </TableCell>
                          <TableCell>
                            {field.initiatedBy !== undefined &&
                            field.initiatedBy !== null &&
                            field.initiatedBy !== ''
                              ? field.initiatedBy
                              : 'user'}
                          </TableCell>
                          <TableCell  sx={{maxWidth: '7rem', overflow: 'hidden', textOverflow: 'ellipsis'}}>{props.logs === 'changes' || props.logs === 'external' ? 'Select log for more information' : field.message}</TableCell>
                          <TableCell>{field.result}</TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </DialogContent>
      </Dialog>
    );
  };

  // When Add Application is clicked from the Organizations page
  const AppProvision = (): JSX.Element => {
    const [newApp, setNewApp] = useState<Record<string, string>>({
      userProvisionStatus: 'Approved',
    });
    const [newAppId, setNewAppId] = useState<string>('');

    const handleNewAppChange = (e: string) => {
      if (e) {
        setNewAppId(e);
        switch (adminCredentials.allApplications[e]) {
          default:
            setNewApp({ userProvisionStatus: 'Approved' });
        }
      }
    };

    const addApp = () => {
      setProvisionAppPopup(false);
      editUserApplication(newApp, newAppId);
    };
    return (
      <div className="popup">
        <div className="popup-inner app-popup">
          <h1> Add Application for {userActualState.email}</h1>
          <Button
            className="close-btn link-imitation"
            onClick={() => {
              setProvisionAppPopup(false);
            }}
          >
            X
          </Button>
          <div style={{
            "overflow": "hidden",
            "display": "flex",
            "flexDirection": "column"
          }} >
            <Autocomplete
              id="provisionApp"
              fullWidth
              options={[''].concat(adminProvisionableApps)}
              value={newAppId}
              getOptionLabel={(option: string) =>
                option !== '' ? adminCredentials.allApplications[option]?.name : 'Select an application'
              }
              renderInput={(params) => (
                <TextField {...params} label={`Application to Provision`} />
              )}
              onChange={(_: any, value: string | null) => {
                if (value === null) return;
                handleNewAppChange(value);
              }}
              style={{
                "marginTop": "5px"
              }}
            />
            <br />
            {newAppId !== '' && appClaims !== undefined ? (
              <ApplicationEdit
                forOrg={editingGlobalApps ? undefined : organizationToEdit}
                appInformation={newApp}
                selectedApp={newAppId}
                editUserApplication={editUserApplication}
                appExternalEnums={appExternalEnums}
                setAppExternalEnums={setAppExternalEnums}
                newApp={true}
                updateApp={setNewApp}
                claims={appClaims[newAppId] !== undefined && appClaims[newAppId] !== null ? appClaims[newAppId]! : []}
                resetApp={() => {
                  setNewApp({ userProvisionStatus: 'Approved' });
                }}
              />
            ) : null}
          </div>
          <div className="button-bar">
            <Button
              onClick={() => {
                setProvisionAppPopup(false);
              }}
            >
              Cancel
            </Button>
            <Button disabled={(newAppId === '') || (!appClaimsValid(appClaims?.[newAppId], newApp))} onClick={addApp}>Add Application</Button>
          </div>
        </div>
      </div>
    );
  };

  const EditExistingApp = (props: {
    appData: Record<string, string>,
    forOrg?: string,
    selectedApp: string,
    editUserApplication: (data: Record<string, string>, appId: string) => void,
    claims: Claims[]
  }): JSX.Element => {
    const [app, setApp] = useState<Record<string, string>>({
      ...props.appData
    });

    return (
      <ApplicationEdit
        forOrg={props.forOrg}
        appInformation={app}
        appExternalEnums={appExternalEnums}
        setAppExternalEnums={setAppExternalEnums}
        selectedApp={props.selectedApp}
        editUserApplication={props.editUserApplication}
        claims={props.claims}
        updateApp={setApp}
        resetApp={() => { setApp(props.appData ? { ...props.appData } : {}); }}
      />
    )
    
  }

  const resetMFA = async (userId: string, userCountry: string) => {
    const body = { id: userId, country: userCountry, organizationId: organizationToEdit };
    triggerPopUp("Working...");
    const response = await COSMOS_API.POST(
      body,
      POST_ENDPOINT.ResetMFA,
      getToken()
    );

    if (response.ok) {
      setShowMsg(false);
      enqueueSnackbar('MFA has been reset. The next time a user logs into an app with MFA they will be prompted to set it.', {variant: 'success'});
    } else {
      triggerPopUp('Failed to reset MFA.');
    }
  };

  const changeValidations = async (
    verifyEmail: boolean,
    changePassword: boolean
  ) => {
    setShowEmailPasswordValidations(false);
    triggerPopUp('Working');

    const flagBody = {
      id: userActualState.id,
      country: userActualState.country,
      emailVerificationFlag: verifyEmail,
      passwordResetFlag: changePassword,
      organizationId: organizationToEdit
    };

    const response = await COSMOS_API.POST(
      flagBody,
      POST_ENDPOINT.ResetUserFlags,
      getToken()
    );

    if (response.ok) {
      setShowMsg(false);
      enqueueSnackbar('Flag successfully set, next time the user logs in they will be prompted to perform these actions.', {variant: 'success'});
      dispatch({
        type: UserUpdateAction.TOPLEVEL,
        payload: { field: 'emailVerificationFlag', data: verifyEmail },
      });
      dispatch({
        type: UserUpdateAction.TOPLEVEL,
        payload: { field: 'passwordResetFlag', data: changePassword },
      });
    } else {
      triggerPopUp(
        'There was an error processing the request, please try again.'
      );
    }
  };

  const EmailPasswordValidations = (): JSX.Element => {
    const [validateEmail, setValidateEmail] = useState<boolean>(
      temporaryEdit.emailVerificationFlag === true
    );
    const [changePassword, setChangePassword] = useState<boolean>(
      temporaryEdit.passwordResetFlag === true
    );
    return (
      <Dialog open={showEmailPasswordValidations} onClose={() => setShowEmailPasswordValidations(false)}>
          <DialogTitle><Typography variant='h4'> Set Email and Password Flags</Typography></DialogTitle>
          <DialogContent>
                <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                        disabled={!emailPasswordFlags}
                          checked={validateEmail === true}
                          onChange={() => setValidateEmail(!validateEmail)}
                        />
                      }
                      label="Force revalidate email on next login?"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                        disabled={!emailPasswordFlags}
                          checked={changePassword === true}
                          onChange={() => setChangePassword(!changePassword)}
                        />
                      }
                      label="Force password reset on next login?"
                    />
                </FormGroup>
            </DialogContent>
            <DialogActions>
                  <Button
                    onClick={() => {
                      setShowEmailPasswordValidations(false);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() =>
                      changeValidations(validateEmail, changePassword)
                    }
                  >
                    Change Flags
                  </Button>
            </DialogActions>
        </Dialog>
    );
  };

  const removeOrgFromUser = async (
    orgId: string
  ) => {
    setDeleteOrgPopup(false);
    triggerPopUp('Working');

    const orgRemovalBody = {
      id: userActualState.id,
      country: userActualState.country,
      organizationId: orgId
    };

    const response = await COSMOS_API.POST(
      orgRemovalBody,
      POST_ENDPOINT.DeleteOrgFromUser,
      getToken()
    );

    if (response.ok) {
      await fetchUserData();
      setShowMsg(false);
      enqueueSnackbar('Organization succeessfully removed', {variant: 'success'});
    } else {
      triggerPopUp(
        'There was an error processing the request, please try again.'
      );
    }
  };

  const DeleteOrgFromUser = (): JSX.Element => {
    const [orgToDelete, setOrgToDelete] = useState<string>((temporaryEdit.organizations && (Object.keys(temporaryEdit.organizations).length > 0)) ? Object.keys(temporaryEdit.organizations)[0] : '');
    return (
      <Dialog open={deleteOrgPopUp} onClose={() => setDeleteOrgPopup(false)}>
        <DialogTitle>
          <Typography variant="h4"> Remove Organization from User</Typography>
        </DialogTitle>
        <DialogContent>
        <Alert severity="warning">This will remove all data associated with the selected organization, please proceed with caution!</Alert>
          <Autocomplete
            id="editingOrganization"
            className="organizationSelect"
            fullWidth
            disableClearable
            disabled={!(adminCredentials.isSuperAdmin || (adminCredentials.isOrganizationAdmin && adminCredentials.multiOrg))}
            value={orgToDelete}
            options={organizationList
              .map((customer) => customer?.id)
              .filter(
                (orgId) => temporaryEdit?.organizations[orgId] !== undefined
              )}
            getOptionLabel={(option) =>
              organizationList.find((customer) => customer?.id === option)
                ?.name ?? ''
            }
            renderInput={(params) => (
              <TextField {...params} label={`Organization`} />
            )}
            onChange={(_, value) => setOrgToDelete(value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setDeleteOrgPopup(false);
            }}
          >
            Cancel
          </Button>
          <Button
           color="error"
           disabled={orgToDelete === ''}
            onClick={() => removeOrgFromUser(orgToDelete)}
          >
            Delete Organization
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const DeleteUserVerification = (): JSX.Element => {

    const deleteUserRequest = async () => {
      let resp = await COSMOS_API.POST({ objectId: userActualState.id, country: userActualState.country }, POST_ENDPOINT.DeleteUser, getToken());

      if(resp.ok){
        enqueueSnackbar(`User ${userActualState.email} has been successfully deleted`, {variant: 'success'});
        navigate({
          pathname: "/search-users"
        });
      }
      else {
        enqueueSnackbar(`User ${userActualState.email} wasn't deleted: ${resp.respBody.message}`, {variant: 'error'});
      }
    }
    return (
      <Dialog open={deleteUserModal} onClose={() => setDeleteUserModal(false)}>
          <DialogTitle><Typography variant='h4'>Delete {userActualState.email}?</Typography></DialogTitle>
          <DialogContent>
                <DialogContentText>Please confirm that you wish to delete {userActualState.email}. This action cannot be undone!</DialogContentText>
            </DialogContent>
            <DialogActions>
                  <Button
                    onClick={() => {
                      setDeleteUserModal(false);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() =>
                      deleteUserRequest()
                    }
                  >
                    Confirm
                  </Button>
            </DialogActions>
        </Dialog>
    );
  };

  return (
    <Container component={'main'}>
      <>
        {showMsg ? (
          <PopUp msg={msg} setShowMsg={setShowMsg} showMsg={showMsg} />
        ) : null}
        {provisionAppPopup ? <AppProvision /> : null}
        {provisionOrgPopUp ? <AddOrgToUser
          open={provisionOrgPopUp}
          handleClose={() => setProvisionOrgPopup(false)}
          userId={userActualState.id}
          country={userActualState.country}
          provisionableOrgs={adminCredentials.organizationList.filter((org) => ((!userActualState.organizations) || (!Object.keys(userActualState.organizations).includes(org?.id))))}
          fetchUserData={postOrgProvision}
          appExternalEnums={appExternalEnums}
          setAppExternalEnums={setAppExternalEnums}
          enqueueSnackbar={enqueueSnackbar}
        /> : <></>}
        {deleteOrgPopUp && <DeleteOrgFromUser />}
        {showEmailPasswordValidations ? <EmailPasswordValidations /> : <></>}
        {deleteUserModal ? <DeleteUserVerification /> : <></>}
      </>
      <AuditLogs
        userEmail={temporaryEdit.email}
        userID={temporaryEdit.id}
        logs={auditField}
        setAuditField={setAuditField}
        setShowAuditLogs={setShowAuditLogs}
        showAuditLogs={showAuditLogs}
      />
      <Container>
          <Typography variant="h6">
            Edit User:{' '}
            {(userActualState.lastName || '') +
              ', ' +
              (userActualState.firstName || '')}
          </Typography>
          {temporaryEdit.isActive ? <Alert icon={<CheckIcon fontSize="inherit" />} variant='filled' severity='success'>
          This account is in good standing, and should be able to log in.
</Alert> :  <Alert icon={<ErrorIcon fontSize="inherit" />} variant='filled' severity="error">
This account is inactive, and should not be able to log in to any application.
</Alert>}
        </Container>
        <Box
      sx={{ flexGrow: 1, marginTop: '10px', bgcolor: 'background.paper', display: 'flex', minHeight: 224}}
    >
        <Tabs
        orientation="vertical"
        variant="scrollable"
        value={viewPanel}
          onChange={(e, index) => {
            if (index == 2) {
              setEditingGlobalApps(true);
            } else {
              setEditingGlobalApps(false);
            }
            setViewPanel(index);
          }}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: 'divider' }}
      >
        <Tab label="General" value={0}/>
        <Tab label="Organization" value={1}/>
        {temporaryEdit.applications && Object.keys(temporaryEdit.applications).length > 0 && <Tab label="Global Apps" value={2}/>}
        {globalClaimsSchema.length > 0 && <Tab label="Global Claims" value={3}/>}
        {APPSETTINGS.showGroupsPage && adminCanViewSomeGroups(adminCredentials) && <Tab label="Groups" value={4}/> }
      </Tabs>
        <TabPanel index={0} value={viewPanel}>
          <Grid container direction={'row'} spacing={4}>
            <Grid md={8}>
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>{temporaryEdit.id}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}> Data Residency Country <Tooltip title="The location of this user's data will depend on the data location configured for this country." sx={{marginLeft: '8px'}}><InfoOutlinedIcon fontSize='small'/></Tooltip></TableCell>
                      <TableCell>
                        {
                          country_options.find(
                            (option) => option.value === temporaryEdit.country
                          )?.label
                        }
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell> Email Address</TableCell>
                      <TableCell>
                        {!emailEdit ? (
                          <Typography>{temporaryEdit.email || ''}</Typography>
                        ) : (
                          <TextField
                            name="email"
                            disabled={!emailEdit}
                            value={temporaryEdit.email || ''}
                            onChange={(e) =>
                              dispatch({
                                type: UserUpdateAction.TOPLEVEL,
                                payload: {
                                  field: e.target.name,
                                  data: e.target.value,
                                },
                              })
                            }
                          />
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell> First Name </TableCell>
                      <TableCell>
                        {!generalEdit ? (
                          <Typography>{temporaryEdit.firstName || ''}</Typography>
                        ) : (
                          <TextField
                            name="firstName"
                            disabled={!generalEdit}
                            value={temporaryEdit.firstName || ''}
                            onChange={(e) =>
                              dispatch({
                                type: UserUpdateAction.TOPLEVEL,
                                payload: {
                                  field: e.target.name,
                                  data: e.target.value,
                                },
                              })
                            }
                          />
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell> Last Name </TableCell>
                      <TableCell>
                        {!generalEdit ? (
                          <Typography>{temporaryEdit.lastName || ''}</Typography>
                        ) : (
                          <TextField
                            name="lastName"
                            disabled={!generalEdit}
                            value={temporaryEdit.lastName || ''}
                            onChange={(e) =>
                              dispatch({
                                type: UserUpdateAction.TOPLEVEL,
                                payload: {
                                  field: e.target.name,
                                  data: e.target.value,
                                },
                              })
                            }
                          />
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell> Last Email Validation </TableCell>
                      <TableCell>
                        <Typography>
                          {new Date(
                            temporaryEdit.lastEmailValidationDate * 1000
                          ).toLocaleString() ?? ''}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell> Last Password Reset </TableCell>
                      <TableCell>
                        <Typography>
                          {new Date(
                            temporaryEdit.lastPasswordResetDate * 1000
                          ).toLocaleString() ?? ''}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell> Last Login </TableCell>
                      <TableCell>
                        <Typography>
                          {new Date(
                            temporaryEdit.lastLoginDate * 1000
                          ).toLocaleString() ?? ''}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid container md={4} direction={'column'}>
              <Accordion>
              <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="audit-logs-content"
            id="audit-logs-header"
          >
            Audit Logs
          </AccordionSummary>
          <AccordionDetails>
          <List>
                    {((adminCredentials.isSuperAdmin) || (!APPSETTINGS.privilegedLogTypes?.includes('login'))) && (
                  <ListItem>
                    <ListItemButton onClick={() => viewLogs('login')}>
                      View member login attempts
                    </ListItemButton>
                  </ListItem>
                    )}
                    {((adminCredentials.isSuperAdmin) || (!APPSETTINGS.privilegedLogTypes?.includes('email'))) && (
                  <ListItem>
                    <ListItemButton onClick={() => viewLogs('email')}>
                      View member email
                    </ListItemButton>
                  </ListItem>
                    )}
                    {((adminCredentials.isSuperAdmin) || (!APPSETTINGS.privilegedLogTypes?.includes('external'))) && (
                  <ListItem>
                    <ListItemButton onClick={() => viewLogs('external')}>
                      View member external calls
                    </ListItemButton>
                  </ListItem>
                    )}
                    {((adminCredentials.isSuperAdmin) || (!APPSETTINGS.privilegedLogTypes?.includes('changes'))) && (
                  <ListItem>
                    <ListItemButton onClick={() => viewLogs('changes')}>
                      View member info change
                    </ListItemButton>
                  </ListItem>
                    )}
                </List>
          </AccordionDetails>
              </Accordion>
              {editPower ? (
                <>
                <Accordion>
              <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="actions-content"
            id="actions-header"
          >
            Actions
          </AccordionSummary>
          <AccordionDetails>
          <List>
                      {generalEdit ||
                      emailEdit ? (
                        <>
                          <ListItem>
                            <ListItemButton
                              onClick={(e) => {
                                userSave(e);
                              }}
                            >
                              Save
                            </ListItemButton>
                          </ListItem>
  
                          <ListItem>
                            <ListItemButton onClick={(e) => cancelEditState(e)}>
                              Discard Changes
                            </ListItemButton>
                          </ListItem>
                        </>
                      ) : (
                        <>
                          {emailPasswordFlags ? (
                            <ListItem>
                              <ListItemButton
                                onClick={() =>
                                  setShowEmailPasswordValidations(true)
                                }
                              >
                                Validate Email or Change Password
                              </ListItemButton>
                            </ListItem>
                          ) : (
                            <></>
                          )}
                          {(!AppEnvSetting.disableEmailChange && !temporaryEdit.isScimUser) ? 
                          <ListItem>
                            <ListItemButton onClick={() => setEmailEdit(true)}>
                              Change Email
                            </ListItemButton>
                            </ListItem> : <></>
                          }
                          <ListItem>
                            <ListItemButton
                              onClick={() =>
                                resetMFA(temporaryEdit.id, temporaryEdit.country)
                              }
                            >
                              Reset MFA
                            </ListItemButton>
                          </ListItem>
                          <ListItem>
                            <ListItemButton onClick={() => temporaryEdit.isScimUser ? enqueueSnackbar('The user added by scim application cannot be edited', {variant: 'info'}) : setGeneralEdit(true)}>
                              Edit User Details
                            </ListItemButton>
                          </ListItem>
                          {adminCredentials.isSuperAdmin || adminCredentials.isOrganizationAdmin ? (
                            <ListItem>
                              <ListItemButton onClick={(e) => temporaryEdit.isScimUser ? enqueueSnackbar('The user added by scim application cannot be activated / deactivated', {variant: 'info'}) : changeIsActive(e)}>
                                {temporaryEdit.isActive ? (
                                  <>Deactivate Member</>
                                ) : (
                                  <>Activate Member</>
                                )}
                              </ListItemButton>
                            </ListItem>
                          ) : (
                            <></>
                          )}
                          {adminCredentials.isSuperAdmin ? (
                            <ListItem>
                              <ListItemButton onClick={(e) => setDeleteUserModal(true)}>
                                  <>Delete Member</>
                              </ListItemButton>
                            </ListItem>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </List>
          </AccordionDetails>
              </Accordion>
                </>
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel index={1} value={viewPanel}>
          <Grid container spacing={4}>
            <Grid container spacing={1} direction={'column'} sx={{ width: '100%', marginBottom: '2rem', display: (adminCredentials.isSuperAdmin || adminCredentials.multiOrg) ? 'inherit': 'none' }}>
              <Grid xs={12}><Typography variant='h6'>Organizations</Typography></Grid>
              <Grid container xs={12} direction={'row'}>
                <Grid xs={12} sm={7}>
                  <Autocomplete
                    id="editingOrganization"
                    className="organizationSelect"
                    disableClearable
                    size='small'
                    disabled={!(adminCredentials.isSuperAdmin || adminCredentials.multiOrg)}
                    value={organizationToEdit}
                    options={organizationList
                      .map((customer) => customer?.id)
                      .filter(
                        (orgId) => temporaryEdit.organizations?.[orgId] !== undefined
                      )}
                    getOptionLabel={(option) =>
                      organizationList.find((customer) => customer?.id === option)
                        ?.name ?? ''
                    }
                    renderInput={(params) => (
                      <TextField {...params} label={`Organization`} />
                    )}
                    onChange={(_, value) => setOrganizationToEdit(value)}
                  />
                </Grid>
                <Grid xs={4}>
                  <Stack direction="row" spacing={2}>
                      <Button
                      variant='contained'
                        onClick={() => setProvisionOrgPopup(true)}
                        >
                          Add
                        </Button>
                        <Button 
                      variant='contained'
                        color="error"
                        onClick={() => setDeleteOrgPopup(true)}
                        >
                          Delete
                        </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
            <Grid container xs={12}>
              <Grid xs={12}><Typography variant='h6'>Applications</Typography></Grid>
              <Grid container xs={12} direction={'row'}>
                <Grid xs={12} sm={7}>
                  <Autocomplete
                    id="editingApplication"
                    className="applicationSelect"
                    disableClearable
                    size='small'
                    disabled={temporaryEdit.organizations?.[organizationToEdit] === null ||
                      temporaryEdit.organizations?.[organizationToEdit] ===
                        undefined}
                    value={selectedApp}
                    options={[''].concat(temporaryEdit.organizations && temporaryEdit.organizations[organizationToEdit] !== undefined ? Object.keys(temporaryEdit.organizations[organizationToEdit])
                      .filter((app) => app !== ORG_SHARED_DATA && adminProvisionableApps.includes(app))
                      .sort((a, b) =>
                        adminCredentials.allApplications[a]?.name <= adminCredentials.allApplications[b]?.name
                          ? -1
                          : 1
                      ) : [])}
                    getOptionLabel={(option) =>
                      option === '' ? 'Please select an application' : adminCredentials.allApplications[option]?.name ?? ''
                    }
                    renderInput={(params) => (
                      <TextField {...params} label={`Application`} />
                    )}
                    onChange={(_, value) => setSelectedApp(value)}
                  />
                </Grid>
                {(!AppEnvSetting.disableAppProvisioning) && adminProvisionableApps.length > 0 && <Grid xs={4}>
                <Button
                      variant='contained'
                  onClick={() => setProvisionAppPopup(true)}
                >
                  Add application
                </Button>
                </Grid>}
              </Grid>
              {selectedApp !== undefined && selectedApp !== '' && appClaims !== undefined && organizationToEdit && temporaryEdit.organizations && temporaryEdit.organizations[organizationToEdit] ? (
              <EditExistingApp
                forOrg={organizationToEdit}
                appData={
                  temporaryEdit.organizations[organizationToEdit][selectedApp]
                }
                selectedApp={selectedApp}
                editUserApplication={editUserApplication}
                claims={appClaims[selectedApp] !== undefined && appClaims[selectedApp] !== null ? appClaims[selectedApp]! : []}
              />
            ) : null}
            </Grid>
          </Grid>
        </TabPanel>
        {temporaryEdit.applications && (Object.keys(temporaryEdit.applications).length > 0) && 
        <TabPanel index={2} value={viewPanel}>
          <Grid container spacing={4}>
            <Grid container spacing={1} direction={'column'} sx={{ width: '100%', marginBottom: '2rem', display: 'inherit' }}>
              <Grid xs={12}><Typography variant='h6'>Global Applications</Typography></Grid>
              <Grid container xs={12} direction={'row'}>
                <Grid xs={12} sm={7}>
                  <Autocomplete
                    id="editingGlobalApp"
                    className="applicationSelect"
                    disableClearable
                    size='small'
                    value={selectedApp}
                    options={[''].concat((!!temporaryEdit.applications) ? Object.keys(temporaryEdit.applications).filter((app) => app !== ORG_SHARED_DATA && adminProvisionableApps.includes(app)).sort((a, b) =>
                      adminCredentials.allApplications[a]?.name <= adminCredentials.allApplications[b]?.name
                        ? -1
                        : 1
                    ) : [])}
                    getOptionLabel={(option) =>
                      option === '' ? "Please select an application" :
                      adminCredentials.allApplications[option]?.name ?? ''
                    }
                    renderInput={(params) => (
                      <TextField {...params} label={`Application`} />
                    )}
                    onChange={(_, value) => setSelectedApp(value)}
                  />
                </Grid>
                {(!AppEnvSetting.disableAppProvisioning) && adminProvisionableApps.length > 0 && <Grid xs={4}>
                    <Button
                          variant='contained'
                      onClick={() => setProvisionAppPopup(true)}
                    >
                      Add application
                    </Button>
                  </Grid>}
              </Grid>
            </Grid>
            <Grid container xs={12}>
              {selectedApp !== undefined && selectedApp !== '' && appClaims !== undefined ? (
              <EditExistingApp
                appData={
                    temporaryEdit.applications?.[selectedApp] ?? null
                }
                selectedApp={selectedApp}
                editUserApplication={editUserApplication}
                claims={appClaims[selectedApp] !== undefined && appClaims[selectedApp] !== null ? appClaims[selectedApp]! : []}
              />
            ) : null}
            </Grid>
          </Grid>
        </TabPanel>
        }
        {globalClaimsSchema.length > 0 && <TabPanel index={3} value={viewPanel}>
          <Grid container spacing={4}>
            <Grid container spacing={1} direction={'column'} sx={{ width: '100%', marginBottom: '2rem', display: 'inherit' }}>
              <Grid xs={12}><Typography variant='h6'>Global Claims</Typography></Grid>
            </Grid>
            <Grid container xs={12}>
              <ClaimsEdit
                claimContext={{ ...userActualState.global }}
                updateClaims={saveUserGlobalClaims}
                claimsValid={globalClaimsValid}
                claimsSchema={globalClaimsSchema}
              />
            </Grid>
          </Grid>
        </TabPanel>
        }
        {APPSETTINGS.showGroupsPage && adminCanViewSomeGroups(adminCredentials) && (
          <TabPanel index={4} value={viewPanel}>
            <Grid container spacing={4}>
              <Grid container spacing={1} direction={'column'} sx={{ width: '100%', marginBottom: '2rem', display: 'inherit' }}>
                <Grid xs={12}><Typography variant='h6'>Groups</Typography></Grid>
              </Grid>
              <Grid container xs={12}>
                <EditGroupMembership
                  objectId={userActualState.id}
                  country={userActualState.country}
                  userGroups={userGroupState}
                  setUserGroupState={setUserGroupState}
                  enqueueSnackbar={enqueueSnackbar}
                />
              </Grid>
            </Grid>
          </TabPanel>
        )}
        </Box>
    </Container>
  );
}
export { EditComponent };
